import localforage from 'localforage';

// create storage instance
export const store = localforage.createInstance({
  name: 'realtime_fld',
});
